import { CardBody, CardHeader, Heading } from '@chakra-ui/react';
import React from 'react';
import { localise } from '../../../services/lang/lang';
import InspectionDetailCard from '../../pages/upgrade/InspectionDetail/InspectionDetailCard';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
import ContactsShareContent from './Share/ContactsShareContent';
import ContactsContent from './ContactsContent';
import RenderIfElse from '../RenderIf/RenderIfElse';
const ContactsWrapper = ({ inspection }) => {
    const { isShare } = useInspectionDetailContext();
    return (React.createElement(InspectionDetailCard, { "data-testid": "contacts_wrapper" },
        React.createElement(CardHeader, null,
            React.createElement(Heading, { variant: "dk-800-lt-4" }, localise('CONTACTS'))),
        React.createElement(CardBody, { padding: 0 },
            React.createElement(RenderIfElse, { condition: !!isShare, then: React.createElement(ContactsShareContent, { inspection: inspection }), else: React.createElement(ContactsContent, { inspection: inspection }) }))));
};
export default ContactsWrapper;
